/**
 * Extracts the latitude and longitude values from a given URL based on the 'startPoint' query parameter.
 *
 * The expected URL format is "?startPoint=latitude,longitude".
 * If the format is valid, it returns an object with `lat` and `lon` properties.
 * Otherwise, it returns null.
 *
 * @param {string} url - The URL from which the latitude and longitude values are to be extracted.
 * @returns {{ lat: number, lon: number } | null} - An object containing the latitude and longitude values, or null if invalid.
 *
 * @example
 * const url = "https://yourwebsite.com/plan-trail?startPoint=53.5,-7.5";
 * const result = getLatLonFromURL(url);
 * // Returns: { lat: 53.5, lon: -7.5 }
 */
export function getLatLonFromURLForPlannedTrail(url: string): { lat: number, lon: number } | null {
  const urlObj = new URL(url);
  const startPoint = urlObj.searchParams.get('startPoint');

  if (startPoint) {
    const [lat, lon] = startPoint.split(',').map(coord => parseFloat(coord.trim()));

    // Check if lat and lon are valid numbers
    if (!isNaN(lat) && !isNaN(lon)) {
      return { lat, lon };
    }
  }

  return null;
}
